export default __webpack_public_path__ + "static/Post-DisasterPlanning-2036a02725311d17aa74ed3803727d83.jpg";